import script from "./LocaleSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./LocaleSelector.vue?vue&type=script&setup=true&lang=ts"

import "./LocaleSelector.vue?vue&type=style&index=0&id=1d12b73a&lang=scss"

const __exports__ = script;

export default __exports__